var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelaxDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2389_103145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.475 5.16797L10.6 1.40625C10.4163 1.30475 10.2099 1.25151 10 1.25151C9.79013 1.25151 9.58369 1.30475 9.4 1.40625L2.525 5.16953C2.32866 5.27696 2.16477 5.43512 2.05043 5.62752C1.93609 5.81991 1.87551 6.03948 1.875 6.26328V13.7352C1.87551 13.959 1.93609 14.1785 2.05043 14.3709C2.16477 14.5633 2.32866 14.7215 2.525 14.8289L9.4 18.5922C9.58369 18.6937 9.79013 18.7469 10 18.7469C10.2099 18.7469 10.4163 18.6937 10.6 18.5922L17.475 14.8289C17.6713 14.7215 17.8352 14.5633 17.9496 14.3709C18.0639 14.1785 18.1245 13.959 18.125 13.7352V6.26406C18.1249 6.03986 18.0645 5.81981 17.9502 5.62696C17.8358 5.43412 17.6717 5.27559 17.475 5.16797ZM10 2.5L16.2773 5.9375L13.9508 7.21016L7.67344 3.77266L10 2.5ZM10 9.375L3.72266 5.9375L6.37187 4.48672L12.6492 7.92422L10 9.375ZM16.875 13.7383L10.625 17.1594V10.4555L13.125 9.0875V11.875C13.125 12.0408 13.1908 12.1997 13.3081 12.3169C13.4253 12.4342 13.5842 12.5 13.75 12.5C13.9158 12.5 14.0747 12.4342 14.1919 12.3169C14.3092 12.1997 14.375 12.0408 14.375 11.875V8.40312L16.875 7.03516V13.7352V13.7383Z",
    fill: "#FFCE73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2389_103145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxDelivery);
export default __webpack_public_path__ + "static/media/relax_delivery.efe1ae20eefd8dcd7f9cfe3ae98ddcec.svg";
export { ForwardRef as ReactComponent };